<div class="footer-legal-combi">
    <div class="footer-frame">
        <div class="link-frame">
            <a href="https://github.com/Imiphon"><img src="assets/icons/github-button.png" alt="git-link"></a>
            <a href="#contactFrame"><img src="assets/icons/email.png" alt="email-link"></a>
            <a href="https://www.linkedin.com/in/lars-mensching-6ab482299/"><img src="assets/icons/linkedIn.png"
                    alt="linkedIn-link"></a>
            <a id="xing" href="https://www.xing.com/profile/Lars_Mensching2"><img src="assets/icons/xing-logo-sw.png"
                    alt="email-link"></a>
        </div>

        <div class="logo-brand-frame">
            <div class="logo"><img src="assets/images/favicon.png" alt=""></div>
            <div class="brand">&copy; Lars Mensching 2024</div>
        </div>
    </div>

    <div class="legalNote" (click)="toggleLegalNotice()">
        <p>Legal Notice</p>
    </div>

</div>